<div class="modal-header justify-content-center">
  <h4>{{ merchant?.name }}</h4>
</div>
<div class="modal-body">
  <div class="container">
    <div class="row justify-content-center">
      <label><i class="fas fa-phone"></i> {{ merchant?.tel }}</label>
    </div>
    <div class="row justify-content-center">
      <label><i class="fas fa-envelope"></i> {{ merchant?.email }}</label>
    </div>
    <div class="row justify-content-center mt-4">
      <button class="btn ac-btn-primary col-md-4" (click)="close()">OK</button>
    </div>
  </div>
</div>
